<div class="flex-container">
  <div class="flex-item">
    <h3 class="margin-top-0">{{ 'common.labels.searchCriteria' | transloco }}</h3>
    @if (isAssetSearch) {
      <div>
        <div class="flex-container">
          <span class="flex-item">{{ 'orderSearchCriteria.serialNumber' | transloco }}</span>
          <span class="flex-item-2">{{ searchAsset?.serialNumber }}</span>
        </div>
        @if (shouldDisplayAssetType) {
          <div class="flex-container">
            <span class="flex-item">{{ 'orderSearchCriteria.assetType' | transloco }}</span>
            <span class="flex-item-2">{{ getAssetType() }}</span>
          </div>
        }
      </div>
    }
    @if (isDebtorSearch) {
      <div>
        @if (isIndividual) {
          <div class="flex-container">
            <span class="flex-item">{{ 'orderSearchCriteria.firstName' | transloco }}</span>
            <span class="flex-item-2">{{ searchDebtor?.firstName }}</span>
          </div>
        }
        @if (isIndividual) {
          <div class="flex-container">
            <span class="flex-item">{{ 'orderSearchCriteria.middleName' | transloco }}</span>
            <span class="flex-item-2">{{ searchDebtor?.middleName }}</span>
          </div>
        }
        @if (isIndividual) {
          <div class="flex-container">
            <span class="flex-item">{{ 'orderSearchCriteria.lastName' | transloco }}</span>
            <span class="flex-item-2">{{ searchDebtor?.lastName }}</span>
          </div>
        }
        @if (isIndividual && searchDebtor?.dateOfBirth != null) {
          <div class="flex-container">
            <span class="flex-item">{{ 'orderSearchCriteria.dateOfBirth' | transloco }}</span>
            <span class="flex-item-2">{{ $safeNavigationMigration(searchDebtor?.dateOfBirth) | localizedDate:'yyyy-MM-dd' }}</span>
          </div>
        }
        @if (!isIndividual) {
          <div class="flex-container">
            <span class="flex-item">{{ 'common.labels.businessName2' | transloco }}</span>
            <span class="flex-item-2">{{ searchDebtor?.busName }}</span>
          </div>
        }
        @if (order.jurisdiction == 'QC') {
          <div class="flex-container">
            <span class="flex-item">{{ 'orderSearchCriteria.postalCode' | transloco }}</span>
            <span class="flex-item-2">{{ searchDebtor?.contactDetails?.address?.postalCode }}</span>
          </div>
        }
      </div>
    }
    @if (isRegistrationNumberSearch) {
      <div>
        <div class="flex-container">
          <span class="flex-item">{{ 'common.labels.registrationNumber2' | transloco }}</span>
          <span class="flex-item-2">{{ searchLien?.registrationNumber }}</span>
        </div>
      </div>
    }
  </div>
  @if (shouldShowSearchParameters() && this.searchParameters != null) {
    <div class="flex-item">
      <h3 class="margin-top-0">{{ 'orderSearchCriteria.searchParameters' | transloco }}</h3>
      @if (shouldDisplayExactSimilar) {
        <div class="flex-container">
          <span class="flex-item">{{ 'orderSearchCriteria.exactOnlyResults' | transloco }}</span>
          <span class="flex-item-2">{{ searchParameters.exactOnlyResults ? "YES" : "NO" }}</span>
        </div>
      }
      @if (shouldDisplaySearchFromDate && searchParameters.searchFromDate != null) {
        <div class="flex-container">
          <span class="flex-item">{{ 'orderSearchCriteria.searchFromDate' | transloco }}</span>
          <span class="flex-item-2">{{ searchParameters.searchFromDate | localizedDate:'yyyy-MM-dd' }}</span>
        </div>
      }
      @if (shouldDisplaySearchFromDate && searchParameters.searchToDate != null) {
        <div class="flex-container">
          <span class="flex-item">{{ 'orderSearchCriteria.searchToDate' | transloco }}</span>
          <span class="flex-item-2">{{ searchParameters.searchToDate | localizedDate:'yyyy-MM-dd' }}</span>
        </div>
      }
    </div>
  }
</div>